import React, { useState } from 'react';
import '../css/Login.css'; // optional: for custom styling
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import logo from '../logo.webp';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  

  // const handleLogin = async (e) => {
  //   e.preventDefault();

  //   try {
  //     const res = await fetch('http://localhost:3000/login', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({ email, password }),
  //     });
  //     console.log('response', res);
  //     const data = await res.json();

  //     if (res.ok) {
  //       setMessage(data.message);
  //       console.log('Login successful');
  //       // You can navigate to another page here if needed
  //     } else {
  //       setMessage(data.error || 'Login failed');
  //     }
  //   } catch (error) {
  //     setMessage('Something went wrong');
  //     console.error(error);
  //   }
  // };

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log('email, password', email, password);
    try {
      const response = await axios.post("/api/login", {
        email,
        password,
      });
      setMessage(response.data.message); // Login successful
      if (response.status) {
        console.log("Login success, navigating to dashboard");// Redirect to dashboard
        const user = response.data.user; // 👈 This is where user.email comes from
       console.log('user', user);
      // ✅ Store email in session storage
      sessionStorage.setItem('userEmail', user.email);
      sessionStorage.setItem('userName', user.name); // Optional
      sessionStorage.setItem('userRole', user.role);
        navigate('/dashboard');
        // if (user.role === 'super_admin') {
        //   navigate('/dashboard');
        // } else if (user.role === 'admin') {
        //   navigate('/admindashboard');
        // } else if (user.role === 'hr') {
        //   navigate('/hrdashboard');
        // } else {
        //   navigate('/dashboard'); // fallback
        // }
        //sessionStorage.setItem('userEmail', user.email);
      }
    } catch (error) {
      console.log(error);
      if (error.response?.status === 400) {
    setMessage("Invalid email or password"); // 👈 Clear message for bad credentials
    alert("Invalid email or password");
  } else if (error.response?.data?.error) {
    setMessage(error.response.data.error); // Other server-side error
  } else {
    setMessage("Something went wrong. Please try again.");
  }

      // if (error.response?.data?.error) {
      //   setMessage(error.response.data.error);
      // } else {
      //   setMessage("Something went wrong");
      // }
    }
  };

 const handlelog = async (e) => {
    e.preventDefault();
    navigate('/dashboard');
 }

  return (
    <div className="login-container">
      
      <form onSubmit={handleLogin} className="login-form">
        <div className="logo-placeholder">
              <img src={logo} alt="Company Logo" className="logo-image" />
        </div>
        <h2>Admin Login</h2>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
       
        <button type="submit">Login</button>
        {/* {error && <p className="error">{error}</p>} */}
         {/* <p >
          Don't have an account?{" "}
          <span
            onClick={() => navigate("/")}
            //className="text-blue-600 font-medium cursor-pointer hover:underline"
          >
            Register here
          </span>
        </p> */}
         <div style={{ marginTop: '16px', textAlign: 'center' }}>
          <span 
            onClick={() => navigate('/forgotpassword')}
            style={{
              color: '#007bff',
              cursor: 'pointer',
              textDecoration: 'none',
              fontSize: '14px'
            }}
          >
            Forgot Password?
          </span>
        </div>
      </form>
      
    </div>
  );
};

export default Login;
